import React from 'react';

export const pushListingIntoGtm = (
  payload
) => {
  const gtmListingData = {
    event: 'RT_event',
    'pageType': 'listing',
    'Destination City id': payload.source,
    'Origin City Id': payload.destination,
    'Origin City Name': payload.sourceStation,
    'Destination City Name': payload.destinationStation,
    'Travel Date': payload.doj,
    'AP': getAdvancePurchaseDays(payload.doj),
  };
  if (typeof window.dataLayer == 'object') {
    window.dataLayer.push(gtmListingData);
  }
};

export const pushReviewIntoGtm = (
  searchArguments,
) => {

  const gtmReviewData = {
    event: 'RT_event',
    'pageType': searchArguments.pageType,
    'Destination City id': searchArguments.destination,
    'Origin City Id': searchArguments.source,
    'Origin City Name': searchArguments.sourceStation,
    'Destination City Name': searchArguments.destinationStation,
    'Travel Date': searchArguments.doj,
    'AP': getAdvancePurchaseDays(searchArguments.doj),
    'Train Type': searchArguments.trainType,
    'Tatkal': searchArguments.isTatkal ? 'Yes' : 'No',
    'Price Per Adult': searchArguments.totalFare,
    'Class Type': searchArguments.class,
  };
  localStorage.setItem('_GTMReviewData', JSON.stringify(gtmReviewData));
  if (typeof window.dataLayer == 'object') {
    window.dataLayer.push(gtmReviewData);
  }
};

export const getAdvancePurchaseDays = (departDate) => {
  let year = departDate.substring(0, 4);
  let month = departDate.substring(4, 6);
  let day = departDate.substring(6, 8);
  let dateString = new Date(year, month-1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneDay = 24 * 60 * 60 * 1000;
  const diff = (dateString.getTime() - today.getTime()) / oneDay;
  return Math.floor(diff);

};
